import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useLazyQuery } from "@apollo/client";

import { Form, Input } from "antd";
import { SyncOutlined } from "@ant-design/icons";

import { QUERY_STUDENT_ADDRESS } from "../../../../operations/queries/forms/SIS";
import SyncSISButton from "../../../elements/formItems/SyncSISButton";

const StudentAddressSIS = ({
  form,
  sis,
  id,
  initialValue,
  error,
  disabled = true,
}) => {
  const [studentSIS, setStudentSIS] = useState(initialValue);
  const [getSIS, { data, loading }] = useLazyQuery(QUERY_STUDENT_ADDRESS);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ address: data?.student.address || "" });
    setStudentSIS(data.student.address || "");
  }, [data]);

  return (
    <Form.Item
      label="Address"
      name="address"
      validateStatus={error ? "error" : ""}
      help={error}
    >
      <Input
        onChange={(e) => setStudentSIS(e.target.value)}
        disabled={disabled}
        addonAfter={
          <SyncSISButton
            loading={loading}
            sisValue={sis?.student.address}
            currentValue={studentSIS}
          >
            <SyncOutlined onClick={() => getSIS({ variables: { id: id } })} />
          </SyncSISButton>
        }
      />
    </Form.Item>
  );
};

StudentAddressSIS.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.string.isRequired,
  sis: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default StudentAddressSIS;
